export function money(v) {
  const n = Number(v || 0);
  return `$${n.toLocaleString("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function priceLabel(raw) {
  if (!raw) return "";
  if (typeof raw === "number") return money(raw);
  return String(raw).trim();
}

export function titleCase(s) {
  return String(s || "")
    .replace(/[-_/]+/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export function pageHref(slug) {
  if (!slug) return "/";
  if (slug === "home") return "/";
  return `/${slug}`;
}

/** Build the Enquire Now deep link that prefills the enquiry form. */
export function enquireHref({ type, id, title, image, price, category, brand, url, vehicle }) {
  const p = new URLSearchParams();
  if (type) p.set("refType", type);
  if (id) p.set("refId", id);
  if (title) p.set("refTitle", title);
  if (image) p.set("refImage", image);
  if (price) p.set("refPrice", price);
  if (category) p.set("refCategory", category);
  if (brand) p.set("refBrand", brand);
  if (url) p.set("refUrl", url);
  if (vehicle) p.set("refVehicle", vehicle);
  return `/enquire?${p.toString()}`;
}

export function formatDate(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("en-AU", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  } catch {
    return iso;
  }
}

export function formatDateTime(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString("en-AU", {
      day: "numeric",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
}
